<template>
  <div class="memberIndex">
    <el-dialog
      :visible.sync="blackListShow1"
      title="黑名单供应商状态异常提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>很遗憾，贵司仍在我司黑名单禁用期限内，禁用期截至{{ resultData.EntryTermEndDate }}</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="blackListShow2"
      title="黑名单供应商解禁提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>
          贵司已超过我司黑名单禁用期，处于“待激活”状态，若贵司希望与我司重新合作，请发起“黑名单解禁申请流程”，待我司相关评审通过后方能恢复“合格”状态
        </p>
        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="goToChangeInform()"> 发起黑名单解禁申请流程</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="blackListShow3"
      title="供应商等级异常提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>系统检测到您的供应商等级暂不符合我司在线竞价活动参与要求。如需升级等级，请联系我司项目对接人。</p>
      </div>
    </el-dialog>
    <div class="right">
      <div class="currentMenu">在线竞价> 在线竞价</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">在线竞价</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span class="searhTitle"> 项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>

            <span class="searhTitle">竞价结束时间</span>
            <el-date-picker
              v-model="Query.EvaluationEndTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              class="datepick"
            ></el-date-picker>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table
            class="table_wrap1"
            :data="tableData.slice((currentPage - 1) * PageSize, currentPage * PageSize)"
            style="width: 100%"
            :height="height"
            >" style="width: 100%" :fit="true">
            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="250px"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
            <el-table-column prop="BiddingDate" label="竞价时间" width="300px"></el-table-column>
            <el-table-column prop="CountDown" label="倒计时"></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="btn_wrap">
                  <el-button type="text" size="small" @click="fnBiddingRoom(scope.row.SchemeId, scope.row.ProjectName, scope.row.IsNewSupplier)"
                    >进入竞价室</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      Query: {},
      tableData: [],
      Certify: false,
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      pageSizes: [10, 25, 50, 100],
      // 默认每页显示的条数（可修改）
      PageSize: 25,
      height: window.innerHeight - 268,
      resultData: {},
      blackListShow1: false,
      blackListShow2: false,
      blackListShow3: false
    }
  },
  computed: {},
  mounted() {
    this.AddListener()
    this.fnGetData()
    this.getSupplierData()
    window.addEventListener('storage', (e) => {
      if (e.key == 'OnlineBiddingList') {
        this.fnGetData()
      }
    })
  },
  methods: {
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }

      this.getRequest('Purchase/GetOnlineBiddingList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.OnlineBiddingList
            this.totalCount = this.tableData.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getSupplierData() {
      // var loginToken = window.localStorage.getItem("loginToken");
      this.getRequest('SupplierLogin/MemberCenterData')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.Certify = res.data.logindata.Certify
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    AddListener() {
      window.addEventListener('storage', (e) => {
        if (e.key == 'OnlineBiddingList') {
          this.fnGetData()
        }
      })
    },
    fnBiddingRoom(SchemeId, ProjectName, IsNewSupplier) {
      this.getRequest('SupplierLogin/ValidateBlacklistStatus')
        .then((res) => {
          if (res.data.errcode == 0) {
            if (this.Certify == true) {
              if (IsNewSupplier == true) {
                let routerData = this.$router.resolve({
                  name: 'OnlineBiddingNotice',
                  query: {
                    SchemeId: SchemeId,
                    ProjectName: ProjectName
                  }
                })
                window.open(routerData.href, '_blank')
              } else {
                let routerData = this.$router.resolve({
                  name: 'OnlineBiddingRoom',
                  query: {
                    SchemeId: SchemeId,
                    ProjectName: ProjectName
                  }
                })
                window.open(routerData.href, '_blank')
              }
            } else {
              this.$message.error('您未绑定CA！请先绑定后再进行在线竞价！')
            }
          } else if (res.data.errcode == 1) {
            this.$message.error(res.data.errmsg)
          } else if (res.data.errcode == 2) {
            this.resultData = res.data.resultData
            this.blackListShow1 = true
          } else if (res.data.errcode == 3) {
            this.blackListShow2 = true
          } else if (res.data.errcode == 4) {
            this.blackListShow3 = true
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val
    },
    goToChangeInform() {
      this.$router.push({
        path: '/unbanInform4Member',
        query: {
          ruleForm: '',
          isEnter: false
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.warn_content p {
  text-indent: 2em;
  line-height: 2em;
  font-size: 20px;
}
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    width: 100%;
    background: #e4e4e4;
    // flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.block_wrap {
  display: flex;
}

.left_block {
  flex: 3;

  .flex_block {
    display: flex;

    .block {
      flex: 1;
      background: #fff;
      margin-right: 20px;
      text-align: center;
      align-items: center;
      padding: 13px 0;

      .text1 {
        font-size: 46px;
        color: #219cf8;
      }

      .text2 {
        margin-top: 4px;
        color: #054c81;
      }
    }

    .block:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}

.flex_bottom {
  padding: 10px 15px 3px;
  background: #fff;
  margin-top: 10px;

  .fb_title {
    margin-bottom: 0;
  }
}

.right_block {
  width: 220px;
  background: #fff;
  margin-left: 10px;
  padding: 18px 15px 0;

  .text {
    font-size: 16px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 3px;
    font-weight: bold;
  }

  .row_imgs {
    display: flex;
    margin: 15px 0 25px;

    .img_block {
      flex: 1;
      text-align: center;
      cursor: pointer;

      img {
        margin-bottom: 20px;
      }
    }
  }

  .row_imgs:nth-last-of-type(1) {
    margin-top: 33px;
  }
}

.link {
  color: #0361b1;
  padding-right: 10px;
}
</style>